var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "25px",
    viewBox: "0 0 16 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "318BA41C-B4FC-4390-A515-14666DDB192C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-130.000000, -542.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-Arrow-/-arrow-left-1",
    transform: "translate(130.000000, 542.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.499998235,12 C0.499181025,11.3382977 0.783391099,10.7082987 1.28,10.271 L12.432,0.46 C13.200591,-0.184929277 14.3434732,-0.0983289982 15.0061094,0.655049482 C15.6687456,1.40842796 15.6087582,2.55301564 14.871,3.233 L5.119,11.812 C5.06484525,11.8594692 5.03379078,11.9279857 5.03379078,12 C5.03379078,12.0720143 5.06484525,12.1405308 5.119,12.188 L14.871,20.767 C15.3843369,21.1977441 15.6241001,21.872739 15.497511,22.5307895 C15.3709219,23.18884 14.8978411,23.7267052 14.2613312,23.9362535 C13.6248213,24.1458017 12.9247439,23.9941571 12.432,23.54 L1.284,13.732 C0.786188972,13.2939525 0.500629665,12.6630996 0.499998235,12 Z",
    id: "icon-fill-color"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ce727065.svg";
export { ForwardRef as ReactComponent };